import XYZ from 'ol/source/XYZ';

function xyz(url) {
	return new XYZ({ url:url, crossOrigin: "anonymous", });
}

export default xyz;